import { YesNoOption } from '../global/YesNoOption.enum';
import type { IInterestDisclosure } from './InterestDisclosure.interface';

export default class InterestDisclosure implements IInterestDisclosure {
  isConflict: YesNoOption;
  lenderConflictOfInterest: boolean;
  lenderConflictOfInterestComments: string;
  referralConflictOfInterest: boolean;
  referralConflictOfInterestComments: string;
  otherConflictOfInterest: boolean;
  otherConflictOfInterestComments: string;
  comments: string;

  static build = (data: IInterestDisclosure) => new InterestDisclosure(data);
  static blank = () => new InterestDisclosure();

  /**
   * Constructor
   * @param {IInterestDisclosure} data
   */
  constructor(data?: IInterestDisclosure) {
    this.isConflict = YesNoOption.of(data?.isConflict?.name);
    this.lenderConflictOfInterest = data?.lenderConflictOfInterest === true;
    this.lenderConflictOfInterestComments = data?.lenderConflictOfInterestComments || '';
    this.referralConflictOfInterest = data?.referralConflictOfInterest === true;
    this.referralConflictOfInterestComments = data?.referralConflictOfInterestComments || '';
    this.otherConflictOfInterest = data?.otherConflictOfInterest === true;
    this.otherConflictOfInterestComments = data?.otherConflictOfInterestComments || '';
    this.comments = data?.comments || undefined;
  }
}
